<section class="container-fluid temp-color">
  <div class="row">
    <div class="col-sm-2">
      <nav aria-labelledby="privacy-nav-heading" class="sticky-nav">
        <div class="pagenav">
          <ul>
            <li>
              <a id="privacy-nav-safety" routerLink="online-privacy-policy" routerLinkActive="active">
                Privacy Policy
              </a>
            </li>
            <li>
              <a id="privacy-nav-online" routerLink="consumer-privacy-policy" routerLinkActive="active">
                Consumer Privacy Policy
              </a>
              <ul class="open">
                <li>
                  <a id="privacy-nav-supplemental" routerLink="supplemental-state-privacy" routerLinkActive="active">
                    Supplemental State Privacy Policies
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <a
                id="privacy-nav-financial"
                routerLink="financial-product-privacy-notices"
                routerLinkActive="active"
              >
                Financial Product Privacy Notices
              </a>
            </li>
            <li>
              <a id="privacy-nav-identity" routerLink="identity-theft" routerLinkActive="active">
                Identity Theft
              </a>
            </li>
            <li>
              <a id="privacy-nav-preferences" routerLink="your-privacy-preferences" routerLinkActive="active">
                Your Privacy Preferences
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <div class="col-sm-10">
      <div id="section-level-error-msg-section" class="row">
        <div class="col-sm-12">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</section>
